export const buildImageUrl = (fileKey: string) => `https://images.b2b.brimarex.pl/${fileKey}`;
